import React from 'react'
import { WorkspaceSsoConfigFragment } from 'gqlTypes'

import {
  WorkspaceSettingsEnableSsoPanel,
  WorkspaceSettingsSsoSetupPanel,
} from 'modules/workspace/components'

interface WorkspaceSettingsSsoProps {
  customerId: string
  ssoShortName?: string
  isSsoEnabled: boolean
  config?: WorkspaceSsoConfigFragment
}

export const WorkspaceSettingsSso: React.FC<WorkspaceSettingsSsoProps> = props => {
  const { customerId, ssoShortName, isSsoEnabled, config } = props

  if (ssoShortName) {
    return (
      <WorkspaceSettingsSsoSetupPanel
        customerId={customerId}
        workspaceShortName={ssoShortName}
        isSsoEnabled={isSsoEnabled}
        config={config!}
      />
    )
  }

  return <WorkspaceSettingsEnableSsoPanel customerId={customerId} />
}
